const translations = {
    emptyMessage: 'Add chemicals to see mix order guidance.',
    errorMessage: 'Mix-order advisory temporarily unavailable. Displayed order may be stale.',
    groupHeader: 'Group {{order}} — {{label}}',
    groupLabels: {
        '0': 'Water-Soluble Packets & Compatibility Agents',
        '1': 'Water Conditioners & Microbials (AMS, inoculants, biologicals)',
        '2': 'Dry Granular Products (DF, WDG, G, SG)',
        '4': 'Wettable Powders (WP)',
        '5': 'Soluble Powders (SP)',
        '6': 'Suspension Concentrates (SC/F)',
        '7': 'Emulsifiable Concentrates (EC)',
        '8': 'Water-Soluble Liquids (SL)',
        '9': 'Adjuvants / Surfactants / Drift Retardants'
    },
    issueCodeTitles: {
        FORMULATION_UNKNOWN: 'Formulation unknown — confirm position against the label',
        UAN_AMINE_INCOMPATIBLE: '2,4-D amine incompatible with UAN',
        UAN_DRY_PRE_SLURRY_REQUIRED: 'Dry products require pre-slurry with UAN',
        UAN_SKIP_AMS: 'Skip AMS with UAN carrier'
    },
    issuesTitle: 'Mix order notes',
    loading: 'Computing mix order…',
    title: 'Mix order (Precision Labs sequence)',
    unknownFormulation: 'Unknown',
    unknownGroup: 'Group {{order}}'
};

export default translations;
